import React, {useEffect, useState} from 'react'
import {Container} from './styled'
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
const User = props => {
    const {filter, setFilter} = props.filter
    const [user, setUser] = useState(filter.user ? [...filter.user] : [])
    useEffect(() => {
        setFilter({user: [...user]})
    }, [user])
    return <Container>
        <h5>Operador</h5>
        <Select
            multiple
            value={user}
            displayEmpty
            onChange={({target}) => setUser(target.value)}
            input={<OutlinedInput classes={{root: 'select-operator'}} />}
            classes={{selectMenu: 'select-operator_container'}}
            renderValue={selected => (
                selected.length === 0 ? <em>Todos</em> : <div>
                    {selected.map(value => {
                        let u = props.user.filter(x => x.id === value)
                        return u.length > 0 && <Chip key={value} label={u[0].name}/>
                    })}
                </div>
            )}>
            {props.user && props.user.sort((a, b) => a.name < b.name ? -1 : (a.name > b.name ? 1 : 0)).map(u => (
                <MenuItem key={u.id} value={u.id}>

                    <Checkbox color='primary' checked={user.indexOf(u.id) > -1}/>
                    <ListItemText primary={u.name}/>
                </MenuItem>
            ))}
        </Select>
    </Container>
}

export default User